import { useRef, useState } from "react"
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { formatDate } from '../../utils/helpers'
import Pagination from "../Layout/Pagination"

const CommissionListingTable = ({
  data,
  selected
}) => {
  const inputRef = useRef(null)
  const divRef = useRef(null)
  const [showSearchBox, setShowSearchBox] = useState(false)
  const [filteredData, setFilteredData] = useState(data)

  const [currentPage, setCurrentPage] = useState(1);

  const handleShowSearchBox = () => {
    setShowSearchBox(!showSearchBox)
    if (setShowSearchBox) inputRef.current.focus()
  }

  const handleSearchData = (e) => {
    let searchQuery = e.target.value;
  
    const filteredData = data.filter((row) => {
      return Object.values(row).some((value) => {
        if (typeof value === 'string' || typeof value === 'number') {
          if (typeof value === 'string' && value.toLowerCase().includes(searchQuery.toLowerCase())) {
            return true;
          }
          if (typeof value === 'number' && value.toString().includes(searchQuery)) {
            return true;
          }
        }
        return false;
      });
    });
  
    setCurrentPage(1)
    setFilteredData(filteredData);
    divRef.current.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });
  };

  const ITEMS_PER_PAGE = 10;

  const paginatedData = () => {
    const startIdx = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIdx = startIdx + ITEMS_PER_PAGE;
    return filteredData.slice(startIdx, endIdx);
  };
  

  return (
    <>
      <div className='flex flex-col gap-1'>
        <div className='mb-1 flex items-center justify-between'>
          <p className='font-semibold text-gray-one uppercase'>All Agent Listing - { selected?.CommissionPayToUserBranch }</p>

          <div className='cursor-pointer border border-border pl-8 py-1.5 text-gray-two rounded-[10px] relative flex items-center overflow-hidden bg-white shadow-md'>
            <FontAwesomeIcon
              onClick={ handleShowSearchBox }
              icon={ faMagnifyingGlass }
              className={ 'text-md absolute left-0 p-2 hover:text-primary ' + (showSearchBox ? 'text-primary' : '') }
            />

            <input
              ref={ inputRef }
              type='text'
              onInput={ handleSearchData }
              onBlur={ () => setShowSearchBox(false) }
              placeholder='Search for any keywords'
              className={ 'appearance-none focus-within:outline-none focus-visible:outline-none flex-1 text-xs transition-all duration-300 ' + (showSearchBox ? 'searchbox-open' : 'w-0') }
            />
          </div>
        </div>
      
        <div className='border-border border rounded-[10px] shadow-md overflow-hidden flex-1 relative'>
          <div ref={ divRef } className='w-full h-full overflow-scroll hide-scrollbar bg-gray-200'>
            <div className="md:w-full w-[1080px] h-full">
              <table className="w-full border-collapse bg-white">
                <thead className="border-b border-gray-200 bg-gray-200 text-gray-one sticky top-0">
                  <tr>
                    <th scope="col" className="text-[11px] font-semibold px-3 py-2 whitespace-nowrap text-start">
                      Name
                    </th>
                    <th scope="col" className="text-[11px] font-semibold px-3 py-2 whitespace-nowrap text-center">
                      Branch
                    </th>
                    <th scope="col" className="text-[11px] font-semibold px-3 py-2 whitespace-nowrap text-start">
                      Group Name
                    </th>
                    <th scope="col" className="text-[11px] font-semibold px-3 py-2 whitespace-nowrap text-start">
                      Upline Name
                    </th>
                    <th scope="col" className="text-[11px] font-semibold px-3 py-2 whitespace-nowrap text-center">
                      Joining Date
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedData().map((item, idx) => (
                    <tr key={'agents_' + idx} className="border-gray-200 border-b text-gray-two hover:bg-gray-50">
                      <td className="text-xs font-normal px-3 py-2 border-r whitespace-nowrap text-start">{ item.UserName }</td>
                      <td className="text-xs font-normal px-3 py-2 border-r whitespace-nowrap text-center">{ item.UserBranchName }</td>
                      <td className="text-xs font-normal px-3 py-2 border-r whitespace-nowrap text-start">{ item.UserGroupName }</td>
                      <td className="text-xs font-normal px-3 py-2 border-r whitespace-nowrap text-start">{ item.UserTAName }</td>
                      <td className="text-xs font-normal px-3 py-2 border-r whitespace-nowrap text-center">{ formatDate(item.UserJoiningDate ?? 0)  }</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <Pagination
          data={ filteredData }
          currentPage={ currentPage }
          setCurrentPage={ setCurrentPage }
          perPage={ ITEMS_PER_PAGE }
        />
      </div>
    </>
  )
}

export default CommissionListingTable